import cn from 'classnames'

import { getQBRFormattedPercent } from '../../../../../../helpers/getQBRFormattedPercent'
import { getQBRFormattedUnit } from '../../../../../../helpers/getQBRFormattedUnit'
import styles from '../PlanAchievement.module.scss'

interface IGetUnitsViewCellParameters {
  actualsUnits: number
  plansUnits: number
  actualsToPlans: number
  yoyActuals: number
  isTotal?: boolean
}

export const getUnitsViewCell = ({
  actualsUnits,
  plansUnits,
  actualsToPlans,
  yoyActuals,
  isTotal,
}: IGetUnitsViewCellParameters) => {
  return (
    <div
      className={cn(styles.financialValue, styles.fullView, {
        [styles.total]: isTotal,
      })}
    >
      <p className={cn(styles.paragraph, styles.actuals)}>{getQBRFormattedUnit(actualsUnits)}</p>
      <p className={cn(styles.paragraph, styles.plans)}>{getQBRFormattedUnit(plansUnits)}</p>
      <p
        className={cn(styles.subParagraph, {
          [styles.positive]: actualsToPlans > 100,
          [styles.negative]: actualsToPlans < 100,
        })}
      >
        {getQBRFormattedPercent(actualsToPlans)}
      </p>
      <p
        className={cn(styles.subParagraph, {
          [styles.positive]: yoyActuals > 0,
          [styles.negative]: yoyActuals < 0,
        })}
      >
        {getQBRFormattedPercent(yoyActuals, 'exceptZero')}
      </p>
    </div>
  )
}
